<template>
  <div class="user-group-modal" :class="{ 'user-group-modal--nested': nested }">
    <AppModal :close-on-overlay="nested || !isMobile"
              :max-height="modalMaxHeight"
              :nested="nested"
              :show-close-button="true"
              :title="$t('general.choose_group')"
              :visible.sync="isOpen"
              :width="modalWidth"
    >
      <div class="user-group-body">
        <default-loading v-if="loading" />
        <template v-else>
          <div v-if="groupList && groupList.length > 0" class="user-group-table-wrap">
            <table class="uk-table uk-table-middle uk-table-divider user-group-table">
              <thead>
                <tr>
                  <th>{{ $t('general.group_name') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(group, index) in activeGroups" :key="index">
                  <td>{{ group.name }}</td>
                  <td class="text-right">
                    <button class="uk-button uk-button-default" type="button" @click="selectGroup(group.id)">
                      {{ $t('menu.company_dashboard.create_assignment') }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="uk-alert-warning" uk-alert>
            <p>{{ $t('general.no_groups_available') || 'Atama yapılabilecek kayıt bulunmuyor.' }}</p>
          </div>
        </template>
      </div>
      <template #footer>
        <button class="btn btn-danger" type="button" @click="closeModal">
          {{ $t("general.close") }}
        </button>
      </template>
    </AppModal>
  </div>
</template>

<script>
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import AppModal from "@/view/components/ui/AppModal.vue";

export default {
  name: "UserGroupModal",
  components: {
    DefaultLoading,
    AppModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    nested: {
      type: Boolean,
      default: false
    },
    groups: {
      type: [Array, Object],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMobile: false
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    },
    modalWidth() {
      if (this.nested) {
        return this.isMobile ? "calc(100% - 32px)" : "600px";
      }
      return this.isMobile ? "100%" : "600px";
    },
    modalMaxHeight() {
      if (this.nested) {
        return this.isMobile ? "85vh" : "90vh";
      }
      return this.isMobile ? "100%" : "90vh";
    },
    groupList() {
      if (!this.groups) return [];
      if (Array.isArray(this.groups)) {
        return this.groups;
      }
      if (this.groups.data && Array.isArray(this.groups.data)) {
        return this.groups.data;
      }
      return [];
    },
    activeGroups() {
      return this.groupList.filter(group => group.status);
    }
  },
  methods: {
    updateIsMobile() {
      this.isMobile = typeof window !== "undefined" && window.innerWidth <= 767;
    },
    closeModal() {
      this.isOpen = false;
    },
    selectGroup(groupId) {
      this.$emit('group-selected', groupId);
    }
  },
  watch: {
    visible(isOpen) {
      if (!isOpen) {
        this.$emit('close');
      }
    }
  },
  mounted() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
};
</script>

<style scoped>
.user-group-body {
  min-width: 0;
}

.user-group-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.user-group-table {
  margin-bottom: 0;
}

.uk-button-default {
  transition: all 0.3s ease;
}

.uk-button-default:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
}

@media (max-width: 767px) {
  .user-group-modal:not(.user-group-modal--nested) ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) {
    padding: 0;
    align-items: stretch;
    justify-content: stretch;
  }

  .user-group-modal:not(.user-group-modal--nested) ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal {
    width: 100% !important;
    max-width: 100% !important;
    height: 100%;
    min-height: 100%;
    max-height: 100% !important;
    border-radius: 0;
    box-shadow: none;
  }

  .user-group-modal:not(.user-group-modal--nested) ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-header {
    border-radius: 0;
  }

  .user-group-modal:not(.user-group-modal--nested) ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-title {
    font-size: 16px;
    line-height: 1.4;
  }

  .user-group-modal:not(.user-group-modal--nested) ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-close {
    min-width: 48px;
    min-height: 48px;
  }

  .user-group-modal:not(.user-group-modal--nested) ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-body {
    flex: 1;
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .user-group-modal:not(.user-group-modal--nested) ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-footer {
    padding: 16px;
  }

  .user-group-modal ::v-deep .app-modal-footer .btn {
    min-height: 48px;
    margin: 0;
    border-radius: 10px;
    font-size: 16px;
  }

  .user-group-modal ::v-deep .app-modal-footer .btn:active {
    transform: scale(0.98);
    opacity: 0.85;
  }

  .user-group-table {
    min-width: 420px;
  }

  .user-group-table th,
  .user-group-table td {
    white-space: nowrap;
  }
}

@media (hover: none) {
  .user-group-modal ::v-deep .app-modal-footer .btn:hover,
  .user-group-modal ::v-deep .app-modal-close:hover {
    opacity: 1;
    color: #666;
  }
}

@media (prefers-reduced-motion: reduce) {
  .uk-button-default:hover {
    transform: none;
  }

  .user-group-modal ::v-deep .app-modal-footer .btn:active {
    transform: none;
  }
}
</style>
